import { render } from "./Proveedor_Cliente_Productos.vue?vue&type=template&id=5c89ba73"
import script from "./Proveedor_Cliente_Productos.vue?vue&type=script&lang=js"
export * from "./Proveedor_Cliente_Productos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__